// UP6: the shell status of every environment the notifier watches, read
// through the client runtime's shell atoms. A separate seam so the
// coordinator's story can stand in a status without the connection runtime.
import { useAtomValue } from "@effect/atom-react";
import { Atom } from "effect/unstable/reactivity";
import { useMemo } from "react";
import type { EnvironmentId } from "@cleo/contracts";
import type { EnvironmentShellStatus } from "@cleo/client-runtime/state/shell";

import { environmentShell } from "~/state/shell";

export function useShellStatuses(
  environmentIds: ReadonlyArray<string>,
): ReadonlyMap<string, EnvironmentShellStatus> {
  const key = environmentIds.join(" ");
  const statusesAtom = useMemo(
    () =>
      Atom.make((get) => {
        const statuses = new Map<string, EnvironmentShellStatus>();
        for (const environmentId of key.split(" ").filter(Boolean)) {
          statuses.set(
            environmentId,
            get(environmentShell.stateValueAtom(environmentId as EnvironmentId)).status,
          );
        }
        return statuses;
      }),
    // A new id set is a new atom; the value is re-read on every shell change.
    [key],
  );
  return useAtomValue(statusesAtom);
}
